import * as dayjs from "dayjs";

export const AUTH_MODULES = [
	{
		name: 'Admin Campaigns',
		path: 'admin/campaigns',
		visible: true,
		all: false,
	},
	{ name: 'Billing', path: 'admin/billing', visible: true, all: false },
	{
		name: 'Employee Users',
		path: 'admin/employee-users',
		visible: true,
		all: false,
	},
	{
		name: 'Client Users',
		path: 'admin/client-users',
		visible: true,
		all: false,
	},
	{ name: 'QC Control', path: 'admin/leads', visible: true, all: false },
	{
		name: 'Forecast Range',
		path: 'admin/forecast-range',
		visible: true,
		all: false,
	},
	{
		name: 'Forecast Month',
		path: 'admin/forecast-month',
		visible: true,
		all: false,
	},
	{
		name: 'Forecasst Week',
		path: 'admin/forecast-week',
		visible: true,
		all: false,
	},
	{
		name: 'Black Out Days',
		path: 'admin/black-out-days',
		visible: true,
		all: false,
	},
	{
		name: 'Reschedule Leads',
		path: 'admin/reschedule-leads',
		visible: true,
		all: false,
	},
	{
		name: 'Replacement Leads',
		path: 'admin/replacement-leads',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Feedback',
		path: 'admin/customer-feedback',
		visible: true,
		all: false,
	},
	{
		name: 'Report Feedback',
		path: 'admin/report-feedback',
		visible: true,
		all: false,
	},
	{
		name: 'Login History',
		path: 'admin/history-login',
		visible: true,
		all: false,
	},
	{ name: 'Reports', path: 'admin/reports', visible: true, all: false },
	{
		name: 'Employee Reports',
		path: 'admin/employee-reports',
		visible: true,
		all: false,
	},
	{
		name: 'Lead Report',
		path: 'admin/lead-report',
		visible: true,
		all: false,
	},
	{ name: 'Dashboard', path: 'admin/dashboard', visible: true, all: false },
	{ name: 'Edit Users', path: 'admin/user-edit', visible: true, all: false },
	{
		name: 'Upload Prospects',
		path: 'admin/upload-prospects',
		visible: true,
		all: false,
	},
	{
		name: 'Edit Campaign',
		path: 'admin/campaign-edit',
		visible: true,
		all: false,
	},
	{ name: 'Payments', path: 'admin/payments', visible: true, all: false },
	{
		name: 'Call Report',
		path: 'admin/call-report',
		visible: true,
		all: false,
	},
	{
		name: 'Caller Overview',
		path: 'admin/caller-overview',
		visible: true,
		all: false,
	},
	{
		name: 'Dispo Report',
		path: 'admin/dispo-report',
		visible: true,
		all: false,
	},

	{
		name: 'Caller Campaigns',
		path: 'caller/campaigns',
		visible: true,
		all: false,
	},
	{ name: 'Search', path: 'caller/search', visible: true, all: false },
	{ name: 'DB Reset', path: 'caller/dbreset', visible: true, all: false },
	{ name: 'Dispos', path: 'caller/dispo', visible: true, all: false },
	{
		name: 'Calling View',
		path: 'caller/lead-profile',
		visible: true,
		all: false,
	},

	{
		name: 'Customer Leads',
		path: 'customer/leads',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Calendar',
		path: 'customer/calendar',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Black Out Days',
		path: 'customer/black-out-days',
		visible: true,
		all: false,
	},
	{
		name: 'Customer Account Review',
		path: 'customer/account-review',
		visible: true,
		all: false,
	},

	{
		name: 'Developer Options',
		path: 'developer/options',
		visible: true,
		all: false,
	},
	{ name: 'Add Campaign', path: 'campaign-add', visible: true, all: false },
	{
		name: 'Edit Lead',
		path: 'lead-edit/:selectedLead',
		visible: true,
		all: false,
	},
	{ name: 'Login', path: 'login', visible: false, all: false },
	{
		name: 'Campaign Calendar',
		path: 'campaign-calendar/:id',
		visible: true,
		all: false,
	},
	{
		name: 'All Campaigns Calendar',
		path: 'all-campaign-calendar',
		visible: true,
		all: false,
	},
	{ name: 'Default', path: '', visible: false, all: true },
	{
		name: 'Not Authorized',
		path: 'not-authorized',
		visible: true,
		all: false,
	},
];

// TODO: USE ONE OF THE TWO TIME ZONES
export const TIME_ZONES = [
	{
		name: 'ALASKA DAYLIGHT TIME UTC - 8',
		shortName: 'AKDT',
	},
	{
		name: 'ALASKA TIME UTC - 9',
		shortName: 'AKST',
	},
	{
		name: 'ATLANTIC STANDARD TIME	UTC - 4',
		shortName: 'AST',
	},
	{
		name: 'CENTRAL DAYLIGHT TIME UTC - 5',
		shortName: 'CDT',
	},
	{
		name: 'CENTRAL STANDARD TIME UTC - 6',
		shortName: 'CST',
	},
	{
		name: 'EASTERN DAYLIGHT TIME UTC - 4',
		shortName: 'EDT',
	},
	{
		name: 'EASTERN STANDARD TIME UTC - 5',
		shortName: 'EST',
	},
	{
		name: 'HAWAII-ALEUTIAN DAYLIGHT TIME UTC - 9',
		shortName: 'HADT',
	},
	{
		name: 'HAWAII-ALEUTIAN STANDARD TIME	UTC - 10',
		shortName: 'HAST',
	},
	{
		name: 'HAWAII STANDARD TIME UTC - 10',
		shortName: 'HST',
	},
	{
		name: 'MOUNTAIN DAYLIGHT TIME	UTC - 6',
		shortName: 'MDT',
	},
	{
		name: 'MOUNTAIN STANDARD TIME	UTC - 7',
		shortName: 'MST',
	},
	{
		name: 'PACIFIC DAYLIGHT TIME UTC - 7',
		shortName: 'PDT',
	},
	{
		name: 'PACIFIC STANDARD TIME UTC - 8',
		shortName: 'PST',
	},
];

export const APPT_TYPES = [
	{
		id: 1,
		name: 'face_to_face',
		description: 'Face to Face',
	},
	{
		id: 2,
		name: 'phone',
		description: 'Phone',
	},
	{
		id: 3,
		name: 'zoom',
		description: 'Zoom Meeting',
	},
];

export const INDUSTRIES = [
		{
			id: 1,
			name: '401k',
			description: '401k',
		},
		{
			id: 2,
			name: 'group_health',
			description: 'Group Health',
		},
		{
			id: 3,
			name: 'supplemental',
			description: 'Supplemental',
		},
		{
			id: 4,
			name: 'financial_wellness',
			description: 'Financial Wellness',
		},
		{
			id: 5,
			name: 'peo',
			description: 'PEO',
		},
		{
			id: 6,
			name: 'wc',
			description: "Worker's Comp",
		},
		{
			id: 7,
			name: 'commercial_insurance',
			description: 'Comercial Ins',
		},
		{
			id: 8,
			name: 'prospecting',
			description: 'Prospecting',
		},
		{
			id: 9,
			name: 'merchant_services',
			description: 'Merchant Services',
		},
		{
			id: 10,
			name: 'tax_savings',
			description: 'Tax Savings',
		},
		{
			id: 11,
			name: 'payroll',
			description: 'Payroll',
		},
		{
			id: 12,
			name: 'hro',
			description: 'HRO',
		},
		{
			id: 13,
			name: 'other',
			description: 'Other',
		},
	];

export const CRITERIA_TYPES = [
	{ description: 'Employee Size', selected: false },
	{ description: 'Asset Size', selected: false },
	{ description: 'Plan Particpants', selected: false },
	{ description: 'State', selected: false },
	{ description: 'Zip Code', selected: false },
];

export const CAMPAIGN_EDIT_MENU = [
	{
		text: 'Basic',
		tab_name: 'basic',
		icon: 'fa fa-address-card-o',
	},
	{
		text: 'Criteria',
		tab_name: 'criteria',
		icon: 'fa fa-table',
	},
	{
		text: 'Call sheet',
		tab_name: 'call_sheet',
		icon: 'fa fa-file-text-o',
	},
	{
		text: 'Dispo Log',
		tab_name: 'log',
		icon: 'fa fa-book',
	},
	{
		text: 'Stats',
		tab_name: 'stats',
		icon: 'fa fa-bar-chart',
	},
	{
		text: 'Calendar',
		tab_name: 'calendar',
		icon: 'fa fa-calendar',
	},
	{
		text: 'Contract Rules',
		tab_name: 'contract_rules',
		icon: 'fa fa-usd',
	},
	{
		text: 'Assigned Users',
		tab_name: 'Assigned_users',
		icon: 'fa fa-users',
	},
];

export const MONTHS = [
	{
		fullName: 'January',
		shortName: 'Jan',
		number: '01',
	},
	{
		fullName: 'February',
		shortName: 'Feb',
		number: '02',
	},
	{
		fullName: 'March',
		shortName: 'Mar',
		number: '03',
	},
	{
		fullName: 'April',
		shortName: 'Apr',
		number: '04',
	},
	{
		fullName: 'May',
		shortName: 'May',
		number: '05',
	},
	{
		fullName: 'June',
		shortName: 'Jun',
		number: '06',
	},
	{
		fullName: 'July',
		shortName: 'Jul',
		number: '07',
	},
	{
		fullName: 'Augost',
		shortName: 'Aug',
		number: '08',
	},
	{
		fullName: 'September',
		shortName: 'Sep',
		number: '09',
	},
	{
		fullName: 'October',
		shortName: 'Oct',
		number: '10',
	},
	{
		fullName: 'November',
		shortName: 'Nov',
		number: '11',
	},
	{
		fullName: 'December',
		shortName: 'Dec',
		number: '12',
	},
];

export const STATES = [
	{ name: 'Alabama', shortName: 'AL' },
	{ name: 'Alaska', shortName: 'AK' },
	{ name: 'Arizona', shortName: 'AZ' },
	{ name: 'Arkansas', shortName: 'AR' },
	{ name: 'California', shortName: 'CA' },
	{ name: 'Colorado', shortName: 'CO' },
	{ name: 'Connecticut', shortName: 'CT' },
	{ name: 'Delaware', shortName: 'DE' },
	{ name: 'District of Columbia', shortName: 'DC' },
	{ name: 'Florida', shortName: 'FL' },
	{ name: 'Georgia', shortName: 'GA' },
	{ name: 'Hawaii', shortName: 'HI' },
	{ name: 'Idaho', shortName: 'ID' },
	{ name: 'Illinois', shortName: 'IL' },
	{ name: 'Indiana', shortName: 'IN' },
	{ name: 'Iowa', shortName: 'IA' },
	{ name: 'Kansas', shortName: 'KS' },
	{ name: 'Kentucky', shortName: 'KY' },
	{ name: 'Louisiana', shortName: 'LA' },
	{ name: 'Maine', shortName: 'ME' },
	{ name: 'Maryland', shortName: 'MD' },
	{ name: 'Massachusetts', shortName: 'MA' },
	{ name: 'Michigan', shortName: 'MI' },
	{ name: 'Minnesota', shortName: 'MN' },
	{ name: 'Mississippi', shortName: 'MS' },
	{ name: 'Missouri', shortName: 'MO' },
	{ name: 'Montana', shortName: 'MT' },
	{ name: 'Nebraska', shortName: 'NE' },
	{ name: 'Nevada', shortName: 'NV' },
	{ name: 'New Hampshire', shortName: 'NH' },
	{ name: 'New Jersey', shortName: 'NJ' },
	{ name: 'New Mexico', shortName: 'NM' },
	{ name: 'New York', shortName: 'NY' },
	{ name: 'North Carolina', shortName: 'NC' },
	{ name: 'North Dakota', shortName: 'ND' },
	{ name: 'Ohio', shortName: 'OH' },
	{ name: 'Oklahoma', shortName: 'OK' },
	{ name: 'Oregon', shortName: 'OR' },
	{ name: 'Pennsylvania', shortName: 'PA' },
	{ name: 'Rhode Island', shortName: 'RI' },
	{ name: 'South Carolina', shortName: 'SC' },
	{ name: 'South Dakota', shortName: 'SD' },
	{ name: 'Tennessee', shortName: 'TN' },
	{ name: 'Texas', shortName: 'TX' },
	{ name: 'Utah', shortName: 'UT' },
	{ name: 'Vermont', shortName: 'VT' },
	{ name: 'Virginia', shortName: 'VA' },
	{ name: 'Washington', shortName: 'WA' },
	{ name: 'West Virginia', shortName: 'WV' },
	{ name: 'Wisconsin', shortName: 'WI' },
	{ name: 'Wyoming', shortName: 'WY' },
	{ name: 'Alberta', shortName: 'AB' },
	{ name: 'British Columbia', shortName: 'BC' },
	{ name: 'Manitoba', shortName: 'MB' },
	{ name: 'New Brunswick', shortName: 'NB' },
	{ name: 'Newfoundland and Labrador', shortName: 'NL' },
	{ name: 'Nova Scotia', shortName: 'NS' },
	{ name: 'Northwest Territories', shortName: 'NT' },
	{ name: 'Nunavut', shortName: 'NU' },
	{ name: 'Ontario', shortName: 'ON' },
	{ name: 'Prince Edward Island', shortName: 'PE' },
	{ name: 'Quebec', shortName: 'QC' },
	{ name: 'Saskatchewan', shortName: 'SK' },
	{ name: 'Yukon', shortName: 'YT' },
];

export const TITLES = [
	'Owner',
	'Principal',
	'Chairman',
	'Member',
	'Managing Member',
	'Board Member',
	'Partner',
	'Senior Partner',
	'Junior Partner',
	'President',
	'Vice President',
	'Senior Vice President',
	'Junior Vice President',
	'Executive Vice President',
	'Executive',
	'Manufacturing Executive',
	'Operations Executive',
	'Chief Executive Officer',
	'Chief Financial Officer',
	'Chief Technology Officer',
	'Chief Information Officer',
	'Chief Operating Officer',
	'Chief Administrative Officer',
	'Controller',
	'Director',
	'Executive Director',
	'Administrator',
	'Administrative Assistant',
	'Manager',
	'General Manager',
	'Assistant Manager',
	'Site Manager',
	'Plant Manager',
	'Practice Manager',
	'Operations Manager',
	'Business Manager',
	'Sales Manager',
	'Sales Executive',
	'IT Manager',
	'IT Executive',
	'IT Assistant',
	'Office Manager',
	'Office Administrator',
	'Office Assistant',
	'Finance Manager',
	'Finance Executive',
	'Accountant',
	'Accounting Manager',
	'Accounting Specialist',
	'Billing Manager',
	'Billing Specialist',
	'Bookkeeper',
	'Benefits Manager',
	'Benefits Director',
	'Benefits Coordinator',
	'Benefits Specialist',
	'Benefits Administrator',
	'Senior Benefits Administrator',
	'Junior Benefits Administrator',
	'Payroll Manager',
	'Payroll Administrator',
	'Payroll Clerk',
	'Payroll Specialist',
	'Payroll Assistant',
	'HR Manager',
	'HR Director',
	'HR Coordinator',
	'HR Administrator',
	'HR Generalist',
	'HR Specialist',
	'HR Assistant',
	'Other',
];

export const QC_THEADS = [
	{
		text: 'Id',
		key: 'id',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-5',
	},
	{
		text: 'Creation date',
		key: 'lead_creation',
		visible: true,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Agent',
		key: 'generated_by',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Appt Date',
		key: 'date_generated',
		visible: true,
		type: 'medium',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Time Zone',
		key: 'time_zone',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Phone',
		key: 'primary_phone',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Prospect',
		key: 'prospect_company',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		icon: 'fa fa-hand-pointer-o',
		width: 'tcol-25',
	},
	{
		text: 'Status',
		key: 'replacement_status',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [
			{
				value: 'Approved',
				class: 'bg-success',
				operator: '==',
			},
		],
		width: 'tcol-25',
	},
	{
		text: 'Replaced by',
		key: 'replaced_by',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Replaced for',
		key: 'replace_for',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Meet Type',
		key: 'meet_type',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Difficulty',
		key: 'difficult',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Qualified',
		key: 'calificado',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		width: 'tcol-25',
	},
	{
		text: 'Campaign',
		key: 'campaign_name',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Billed',
		key: 'payed',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Confirmation',
		key: 'confirmation',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Prospect Name',
		key: 'prospect_name',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'City',
		key: 'city',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'State',
		key: 'state',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Zip',
		key: 'zip',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Email',
		key: 'primary_email',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Employee Size',
		key: 'employee_size',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Time In status',
		key: 'change_date',
		visible: false,
		type: 'dateAgo',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-20',
	},
];

export const RESCHEDULE_THEADS = [
	{
		text: 'Id',
		key: 'id',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Lead Creation',
		key: 'lead_creation',
		visible: false,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Appt Date',
		key: 'date_generated',
		visible: true,
		type: 'short',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-20',
	},
	{
		text: 'Phone',
		key: 'primary_phone',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Email',
		key: 'primary_email',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Prospect',
		key: 'prospect_company',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		icon: 'fa fa-hand-pointer-o',
		width: 'tcol-25',
	},
	{
		text: 'Status',
		key: 'replacement_status',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [
			{
				value: 'Approved',
				class: 'bg-success',
				operator: '==',
			},
		],
		width: 'tcol-25',
	},
	{
		text: 'Campaign',
		key: 'campaign_name',
		visible: true,
		type: 'HTML',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-25',
	},
	{
		text: 'Prospect Name',
		key: 'prospect_name',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'City',
		key: 'city',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'State',
		key: 'state',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Zip',
		key: 'zip',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Employee Size',
		key: 'employee_size',
		visible: false,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Time In status',
		key: 'change_date',
		visible: true,
		type: 'dateAgo',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-20',
	},
];

export const FYI_THEADS = [
	{
		text: 'ID',
		key: 'prospect',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-5',
	},
	{
		text: 'Prospect Name',
		key: 'prospect_name',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		width: '',
	},
	{
		text: 'Phone',
		key: 'prospect_phone',
		visible: true,
		type: 'number',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Campaign Name',
		key: 'campaign_name',
		visible: true,
		type: 'string',
		order: '',
		align: 'left',
		cell_class: [],
		width: 'tcol-15',
	},
	{
		text: 'Created',
		key: 'created',
		visible: true,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Callback Date',
		key: 'callback_date',
		visible: true,
		type: 'mediumDate',
		order: '',
		align: 'center',
		cell_class: [],
		width: 'tcol-10',
	},
	{
		text: 'Notes',
		key: 'notes',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
	{
		text: 'Called',
		key: 'called',
		visible: true,
		type: 'string',
		order: '',
		align: 'center',
		cell_class: [],
		width: '',
	},
];

export const DATE_PICKER_RANGE_PAST = {
	'Last Week': [
		dayjs().day(0).subtract(7, 'days').format('YYYY-MM-DD'),
		dayjs().day(6).subtract(7, 'days').format('YYYY-MM-DD'),
	],
	'Last month': [
		dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Past 2 months': [
		dayjs().subtract(2, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Past 3 months': [
		dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
		dayjs().format('YYYY-MM-DD'),
	],
	'Last year': [
		dayjs().startOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
		dayjs().endOf('year').subtract(1, 'year').format('YYYY-MM-DD'),
	],
};

// TODO: Change the constants STATEs across the system
export const STATES_SMALL = [
	{ name: 'Alabama', smallName: 'AL' },
	{ name: 'Alaska', smallName: 'AK' },
	{ name: 'Arizona', smallName: 'AZ' },
	{ name: 'Arkansas', smallName: 'AR' },
	{ name: 'California', smallName: 'CA' },
	{ name: 'Colorado', smallName: 'CO' },
	{ name: 'Connecticut', smallName: 'CT' },
	{ name: 'Delaware', smallName: 'DE' },
	{ name: 'Florida', smallName: 'FL' },
	{ name: 'Georgia', smallName: 'GA' },
	{ name: 'Hawaii', smallName: 'HI' },
	{ name: 'Idaho', smallName: 'ID' },
	{ name: 'Illinois', smallName: 'IL' },
	{ name: 'Indiana', smallName: 'IN' },
	{ name: 'Iowa', smallName: 'IA' },
	{ name: 'Kansas', smallName: 'KS' },
	{ name: 'Kentucky', smallName: 'KY' },
	{ name: 'Louisiana', smallName: 'LA' },
	{ name: 'Maine', smallName: 'ME' },
	{ name: 'Maryland', smallName: 'MD' },
	{ name: 'Massachusetts', smallName: 'MA' },
	{ name: 'Michigan', smallName: 'MI' },
	{ name: 'Minnesota', smallName: 'MN' },
	{ name: 'Mississippi', smallName: 'MS' },
	{ name: 'Missouri', smallName: 'MO' },
	{ name: 'Montana', smallName: 'MT' },
	{ name: 'Nebraska', smallName: 'NE' },
	{ name: 'Nevada', smallName: 'NV' },
	{ name: 'New Hampshire', smallName: 'NH' },
	{ name: 'New Jersey', smallName: 'NJ' },
	{ name: 'New Mexico', smallName: 'NM' },
	{ name: 'New York', smallName: 'NY' },
	{ name: 'North Carolina', smallName: 'NC' },
	{ name: 'North Dakota', smallName: 'ND' },
	{ name: 'Ohio', smallName: 'OH' },
	{ name: 'Oklahoma', smallName: 'OK' },
	{ name: 'Oregon', smallName: 'OR' },
	{ name: 'Pennsylvania', smallName: 'PA' },
	{ name: 'Rhode Island', smallName: 'RI' },
	{ name: 'South Carolina', smallName: 'SC' },
	{ name: 'South Dakota', smallName: 'SD' },
	{ name: 'Tennessee', smallName: 'TN' },
	{ name: 'Texas', smallName: 'TX' },
	{ name: 'Utah', smallName: 'UT' },
	{ name: 'Vermont', smallName: 'VT' },
	{ name: 'Virginia', smallName: 'VA' },
	{ name: 'Washington', smallName: 'WA' },
	{ name: 'West Virginia', smallName: 'WV' },
	{ name: 'Wisconsin', smallName: 'WI' },
	{ name: 'Wyoming', smallName: 'WY' }
  ];

export const DAYS = Array.from({ length: 31 }, (v, k) => (k+1) < 10 ? '0' + (k+1) : (k+1).toString());

// TODO: Add more Years after 2027
export const YEARS = ['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2026', '2027'];

export const SOURCES = [
	{ id: 1, name: 'T3direct Marketing' },
	{ id: 2, name: '401k Depot'},
	{ id: 3, name: 'Toplead'},
];

export const CONTRACT_TYPES = [
	{ id: 1, name: 'Normal' },
	{ id: 2, name: 'Reserve'},
	{ id: 3, name: 'Hourly'}
]

export const PERIODICITY = [
		{ value: 'daily', label: 'Daily' , code : 'D'},
		{ value: 'weekly', label: 'Weekly' , code : 'W'},
		{ value: 'monthly', label: 'Monthly' , code : 'M'},
		{ value: 'quarterly', label: 'Quarterly' , code : 'Q'},
		{ value: 'yearly', label: 'Yearly' , code : 'Y'}
]

export const QC_COLUMNS = [
		{
			name: "ID",
			visible: true,
			prop: "id",
		},
		{
			name: "Creation Date",
			visible: true,
			prop: "lead_creation",
		},
		{
			name: "Agent",
			visible: true,
			prop: "generated_by",
		},
		{
			name: "Appt Date",
			visible: true,
			prop: "date_generated",
		},
		{
			name: "Time Zone",
			visible: false,
			prop: "time_zone",
		},
		{
			name: "Phone",
			visible: true,
			prop: "primary_phone",
		},
		{
			name: "Prospect",
			visible: true,
			prop: "prospect_company",
		},
		{
			name: "Prospect Name",
			visible: false,
			prop: "prospect_name",
		},
		{
			name: "Status",
			visible: true,
			prop: "replacement_status",
		},
		{
			name: "Replaced By",
			visible: false,
			prop: "replaced_by",
		},
		{
			name: "Replace For",
			visible: false,
			prop: "replace_for",
		},
		{
			name: "Meet Type",
			visible: true,
			prop: "meet_type",
		},
		{
			name: "Difficulty",
			visible: true,
			prop: "difficult",
		},
		{
			name: "Qualified",
			visible: true,
			prop: "calificado",
		},
		{
			name: "Campaign Name",
			visible: true,
			prop: "campaign_name",
		},
		{
			name: "Billed",
			visible: true,
			prop: "payed",
		},
		{
			name: "Free Type",
			visible: true,
			prop: "free_type",
		},
		{
			name: "Confirmation",
			visible: true,
			prop: "confirmation",
		},
		{
			name: "City",
			visible: false,
			prop: "city",
		},
		{
			name: "State",
			visible: false,
			prop: "state",
		},
		{
			name: "Zip",
			visible: false,
			prop: "zip",
		},
		{
			name: "Primary Email",
			visible: false,
			prop: "primary_email",
		},
		{
			name: "Employee Size",
			visible: false,
			prop: "employee_size",
		},
		{
			name: "Change Date",
			visible: false,
			prop: "change_date",
		},
	];

	export const CHANGE_TO_CUSTOMER_VIEW = [
	'ltejeda@t3direct.com',
	'vkapella@t3direc.com',
	'hiram@t3direct.com',
];

